import { PLANS } from "../actions/types";

const initialState = {
  plans: {},
  error: null,
  isLoading: false,
  subscriptions: {},
};

export default function subscriptionsReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case PLANS.UPDATE:
      return { ...state, isLoading: payload?.error?.status === 401, error: null, ...payload };

    case PLANS.RESET:
      return initialState;

    default:
      return state;
  }
}
